import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType, computed} from "vue";
import {CascaderItem, VACascaderOptions} from "typings";
import {useCascaderHandler} from "./hooks";

export default /*@__PURE__*/_defineComponent({
  __name: 'VACascader',
  props: {
  // data属性里的key
  value: {
    type: Object as PropType<string | number>,
    required: true
  },
  options: {
    type: Object as PropType<VACascaderOptions | Array<CascaderItem>>,
    required: true
  },
  size: {
    type: String,
  },
  placeholder: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: '100%'
  }
},
  emits: ["update:value","on-change"],
  setup(__props, { expose: __expose, emit: __emit }) {


const emit = __emit
const props = __props

const {data, run: load} = useCascaderHandler(props.options as VACascaderOptions)

const source = computed(()=>{
  return props.options instanceof Array?props.options:data.value
})

const change = (value, selectedOptions) => {
  emit("update:value", value)
  emit("on-change", value, selectedOptions)
}

__expose({load})


return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createBlock(_component_a_cascader, {
    value: __props.value,
    disabled: __props.disabled,
    width: __props.width,
    size: __props.size,
    fieldNames: __props.options.fieldNames,
    options: source.value,
    placeholder: __props.placeholder || '请选择' + __props.options.label,
    "expand-trigger": "hover",
    "change-on-select": "",
    onChange: change
  }, null, 8, ["value", "disabled", "width", "size", "fieldNames", "options", "placeholder"]))
}
}

})